import fb from '../../imgs/SVGs/fb.svg'
import insta from '../../imgs/SVGs/insta.svg'
import github from '../../imgs/SVGs/github.svg'

import fbw from '../../imgs/SVGs/fbw.svg'
import instaw from '../../imgs/SVGs/instaw.svg'
import githubw from '../../imgs/SVGs/githubw.svg'



function SocialMediaSvgs(props) {
  return (
    <div className={`social-media-icons ${props.padding} d-flex`}>
        <a href='https://www.facebook.com/maamardev'> <img src={props.color?fbw:fb} alt='fb'></img> </a>
        <a href='https://www.instagram.com/maamar_dev/'> <img src={props.color?instaw:insta} alt='insta'></img> </a>
        <a href='https://github.com/HaDev17'> <img src={props.color?githubw:github} alt='github'></img> </a>
    </div>
  )
}

export default SocialMediaSvgs